import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type PublisherCollectingSocietyViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  collectingSocietyValue: { displayId: string; id: string } | null;
  cmsAccountNumberValue?: { displayId: string; id: string } | null;
  cmsAccountNumber: string;
};

export const PublisherCollectingSocietyViewForm: React.FC<PublisherCollectingSocietyViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      collectingSocietyValue,
      cmsAccountNumber = "",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupPublisherCollectingSocietyLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowReference
                  label={
                    langStore.PublisherCollectingSocietyCollectingSocietyLabel
                  }
                  selectedValue={langStore.displayIdByLang(
                    collectingSocietyValue?.displayId
                  )}
                />
                <ShowMultiLine
                  value={cmsAccountNumber}
                  label={
                    langStore.PublisherCollectingSocietyCmsAccountNumberLabel
                  }
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
